import { createContext } from 'react';
var IconResolverContext = createContext(undefined);
export default IconResolverContext;
//# sourceMappingURL=IconResolverContext.js.map